// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_gu-a";
export var fulfillmentFormRail = "_gu-9";
export var headerTitleRow = "_gu-c";
export var orderDetailsWrapper = "_gu-7";
export var orderLinkTrigger = "_gu-2";
export var paymentInformationGrid = "_gu-h";
export var paymentSummaryColumn = "_gu-i";
export var shipmentContainer = "_gu-b";
export var shipmentDetailsMainPane = "_gu-8";
export var shipmentNavigationCard = "_gu-5";
export var shipmentNavigationRail = "_gu-3";
export var shipmentNavigationRailHeader = "_gu-4";
export var shipmentSummaryFact = "_gu-e";
export var shipmentSummaryGrid = "_gu-d";
export var shipmentSummaryMetadataRow = "_gu-f";
export var shipmentSummaryTags = "_gu-g";
export var shipmentWorkspace = "_gu-0";
export var shipmentWorkspaceContent = "_gu-6";
export var shipmentWorkspaceHeader = "_gu-1";